module.exports = __webpack_public_path__ + "static/media/MB-logo.b3f29de9.svg";